import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import connect from 'components/lib/connect';
import RoleButton from 'components/admin/users/role_button';
import { Roles } from 'models/role';
import SelectHeader from 'components/admin/lib/select_header';

const UserEditorRoleSelectorContainer = connect(mapStateToProps)(UserEditorRoleSelector);

function mapStateToProps({ isFeatureEnabled }, props) {
  return {
    ...props,
  };
}

export default UserEditorRoleSelectorContainer;

function UserEditorRoleSelector({ className, isBetaEnabled, onChange, value }) {
  const { t } = useTranslation();

  let classNames = classnames('userEditor-roles', className);
  return (
    <div className={classNames}>
      <SelectHeader onClearSelected={onClearSelected} selectedCount={value.length} title={t('Roles')} />
      {renderRoleButtons()}
    </div>
  );

  function renderRoleButtons() {
    let roleIds = _.keys(Roles);
    return <div className="userEditor-roles-selection">{roleIds.map(renderRoleButton)}</div>;
  }

  function renderRoleButton(roleId) {
    return (
      <RoleButton
        handler={roleClickHandler(roleId)}
        isSelected={_.includes(value, roleId)}
        key={roleId}
        name={Roles[roleId].name}
        roleId={roleId}
      />
    );
  }

  function onClearSelected() {
    onChange([]);
  }

  function roleClickHandler(roleId) {
    return () => {
      if (!value.length) {
        onChange([roleId]);
      } else if (_.includes(value, roleId)) {
        onChange(_.filter(value, id => id !== roleId));
      } else {
        if (roleId === 'liveboards' || roleId === 'task-user') {
          onChange([roleId]);
        } else {
          let nextValue = value;
          if (_.find(value, r => r === 'liveboards')) {
            nextValue = _.filter(value, r => r !== 'liveboards');
          } else if (_.find(value, r => r === 'task-user')) {
            nextValue = _.filter(value, r => r !== 'task-user');
          }
          onChange(nextValue.concat(roleId));
        }
      }
    };
  }
}

UserEditorRoleSelector.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export { UserEditorRoleSelector };



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/user_editor/user_editor_role_selector.jsx